import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
const HotelCardOutline = /*#__PURE__*/styled('div')({
  name: "HotelCardOutline",
  class: "htpqtks",
  propsAsIs: false
});
const HotelTopSection = /*#__PURE__*/styled('div')({
  name: "HotelTopSection",
  class: "h3zpdhc",
  propsAsIs: false
});
const HotelDetailsSection = /*#__PURE__*/styled('div')({
  name: "HotelDetailsSection",
  class: "h1ymlkli",
  propsAsIs: false
});
const ImageSkeleton = /*#__PURE__*/styled('div')({
  name: "ImageSkeleton",
  class: "i1lktzoe",
  propsAsIs: false
});
const FreezeExpireAndPrice = /*#__PURE__*/styled('div')({
  name: "FreezeExpireAndPrice",
  class: "f1ffba69",
  propsAsIs: false
});
const PayNowSection = /*#__PURE__*/styled('div')({
  name: "PayNowSection",
  class: "p1yehh7i",
  propsAsIs: false
});
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "bzetw71",
  propsAsIs: false
});
export const HotelCardSkeleton = () => <HotelCardOutline>
    <HotelTopSection>
      <HotelDetailsSection>
        <ImageSkeleton>
          <SkeletonLoader width={70} height={70} />
        </ImageSkeleton>
        <div>
          <SkeletonLoader width={68} height={12} />
          <SkeletonLoader width={178} height={24} marginTop={4} />
          <SkeletonLoader width={68} height={20} marginTop={4} />
        </div>
      </HotelDetailsSection>
      <SkeletonLoader width={188} height={24} marginTop={24} marginBottom={14} />
    </HotelTopSection>
    <FreezeExpireAndPrice>
      <div>
        <SkeletonLoader width={92} height={22} />
        <SkeletonLoader width={48} height={24} />
      </div>
      <div>
        <SkeletonLoader width={132} height={22} />
        <SkeletonLoader width={48} height={24} />
      </div>
    </FreezeExpireAndPrice>
    <PayNowSection>
      <div>
        <SkeletonLoader width={92} height={24} />
        <SkeletonLoader width={48} height={24} />
      </div>
      <SkeletonLoader width={188} height={22} />
    </PayNowSection>
  </HotelCardOutline>;
export const DealFreezeCTASkelton = () => <ButtonWrapper>
    <Flex.Column alignItems="center" justifyContent="center" gap="s400">
      <SkeletonLoader width={280} height={22} />
      <SkeletonLoader width={358} height={48} />
    </Flex.Column>
  </ButtonWrapper>;

require("./SkeletonLoading.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SkeletonLoading.tsx");